import { Link, Accordion, AccordionDetails, AccordionSummary, Box, Typography} from '@mui/material';
import FilingSchedule from '../../../../../types/filers/fillingSchedule';
import FilingScheduleTable from './FilingScheduleTable';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface Props {
    schedule?:FilingSchedule[]
    previousSchedule?:FilingSchedule[]
 }


const LocalPartyCommittee = (props: Props): JSX.Element => {
    return ( 
        <Box>
            <Typography variant="h6" gutterBottom fontWeight={600}>
                Local Party Committees
            </Typography>
            <Typography variant="body1" component={'p'}  gutterBottom>
                Ward, town and city committees of the state political parties are required to file with OCPF (click <Link underline="none" href="https://ocpf2.blob.core.windows.net/pdf/forms/cpf_101_wtc.pdf" target="_blank">here</Link> to download the Statement of Organization form).
            </Typography>
            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography fontWeight={'bold'} variant={'subtitle1'}>Current Filing Schedule</Typography> 
                </AccordionSummary>
                <AccordionDetails>
                    <FilingScheduleTable schedules={props.schedule || []} />
                </AccordionDetails>
            </Accordion>
            
            <Accordion >
                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                    <Typography fontWeight={'bold'} variant={'subtitle1'}>Previous Filing Schedule</Typography> 
                </AccordionSummary>
                <AccordionDetails>
                <FilingScheduleTable schedules={props.previousSchedule || []} />
                </AccordionDetails>
            </Accordion>
        </Box>
    )
};

export default LocalPartyCommittee;